import { render } from "./Modal.vue?vue&type=template&id=20237a44&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=20237a44&lang=scss"
import "./Modal.vue?vue&type=style&index=1&id=20237a44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20237a44"]])

export default __exports__